/* eslint-disable */
import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { FormattedMessage } from "react-intl";
import { Typography, ListItem, ListItemText } from "@material-ui/core";

import { sectionItem } from "../constants/types";
import { styles } from "../constants/styles";

type OwnProps = {
  item: sectionItem;
  setSelectedItemId: (id: string) => void;
  refCallback: (element: any) => void 
};

type Props = OwnProps & WithStyles<typeof styles>;

const SectionsMenu: React.FC<Props> = (props: Props) => {
  const[visited, setVisited] = React.useState<boolean>(false)

  const { classes, item, setSelectedItemId, refCallback } = props;

  const setSelectedItem = (item: sectionItem) => () => {
    if (Boolean(item.level - 1)) {
      setSelectedItemId(item.id);
      setVisited(true)
    }
  };

  return (
    <ListItem ref={refCallback} onClick={setSelectedItem(item)} style={{ paddingLeft: `${(item.level - 1) * 24}px`, height: "24px" }}>
      <ListItemText>
        <Typography className={!Boolean(item.level - 1) ? classes.contentListItemText: visited? classes.listItemTextColorVisited : classes.listItemTextColor}>
          <FormattedMessage {...item.name} />
        </Typography>
      </ListItemText>
    </ListItem>
  );
};

export default withStyles(styles)(SectionsMenu);
